// Regras puras do formulário de cadastro de cartão (sem React, sem API).
// Espelham NormalizeFinancialCreditCardRequest do ERPApi (RN-CARD-53).
import type { CreditCard, CreditCardFormData } from '@/types/financial';

export const emptyCreditCardForm: CreditCardFormData = {
  companyId: 0,
  description: '',
  billingDueDay: null,
  billingCycleDay: null,
  bankNumber: null,
  idAccountsMain: null,
  accountingPlanErpId: null,
};

export const creditCardToForm = (card: CreditCard): CreditCardFormData => ({
  companyId: card.companyId,
  description: card.description ?? '',
  billingDueDay: card.billingDueDay ?? null,
  billingCycleDay: card.billingCycleDay ?? null,
  bankNumber: card.bankNumber ?? null,
  idAccountsMain: card.idAccountsMain ?? null,
  accountingPlanErpId: card.accountingPlanErpId ?? null,
});

const validDay = (day: number | null): boolean => day != null && Number.isInteger(day) && day >= 1 && day <= 31;

/** Erros por campo; objeto vazio = válido. */
export function validateCreditCardForm(form: CreditCardFormData): Partial<Record<keyof CreditCardFormData, string>> {
  const errors: Partial<Record<keyof CreditCardFormData, string>> = {};
  const description = form.description.trim();
  if (!form.companyId) errors.companyId = 'Empresa é obrigatória';
  if (!description) errors.description = 'Descrição é obrigatória';
  else if (description.length > 100) errors.description = 'Descrição deve ter no máximo 100 caracteres';
  if (!validDay(form.billingCycleDay)) errors.billingCycleDay = 'Informe um dia entre 1 e 31';
  if (!validDay(form.billingDueDay)) errors.billingDueDay = 'Informe um dia entre 1 e 31';
  if (!form.idAccountsMain) errors.idAccountsMain = 'Conta de pagamento é obrigatória';
  if (!form.accountingPlanErpId) errors.accountingPlanErpId = 'Categoria é obrigatória';
  return errors;
}

/** Corpo enviado à API: descrição aparada e banco vazio como null. */
export const creditCardPayload = (form: CreditCardFormData): CreditCardFormData => ({
  ...form,
  description: form.description.trim(),
  bankNumber: form.bankNumber?.trim() ? form.bankNumber.trim() : null,
});
